<template>
  <ul>
    <li v-for="product in products" :key="product.key"
      :class="options.background"
    >
     <cart-product :product="product" />
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';
import CartProduct from '@/components/cart/CartProduct.vue';

export default {
  components: { CartProduct },

  props: ['appOptions'],

  data() {
    return {
      defaults: {
        background: 'bg-white',
      },
    };
  },

  computed: {
    options() {
      return {
        ...this.defaults,
        ...this.appOptions,
      };
    },
    ...mapGetters({
      products: ['cart/products'],
    }),
  },

  methods: {
    removeProduct(productToRemove) {
      this.$store.dispatch('cart/removeProduct', productToRemove);
    },
  },
};
</script>
